import React, { useState } from "react";
import { Box, Text, Tooltip, Group, createStyles } from "@mantine/core";
import { CopyToClipboard } from "react-copy-to-clipboard";
import getSymbolFromCurrency from "currency-symbol-map";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const useStyles = createStyles((theme) => ({
  icon: {
    cursor: "pointer",
    color: theme.colors.gray[6],
    "&:hover": {
      color: theme.colors.gray[7],
    },
  },
}));

export default function BundleSortableItem({
  id,
  name,
  currency,
  default_payment_amount,
  default_payment_frequency,
  space_slug,
  onEdit,
  onDestroy
}) {
  const { classes } = useStyles();
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition
  };

  const [copiedToClipboard, setCopiedToClipboard] = useState(false);

  const onCopy = () => {
    setCopiedToClipboard(id);
    setTimeout(() => {
      setCopiedToClipboard(false);
    }, 2000);
  };

  return (
    <Box ref={setNodeRef} style={style}>
      <Group
        sx={{
          borderBottom: "1px solid #eee",
          paddingBottom: "20px",
          marginBottom: "20px",
          alignItems: "flex-start",
        }}
        position="apart"
      >
        <Box style={{ flex: 1 }}>
          <Group>
            <Box>
              <Text size="xl" mb={3} weight={"bold"}>{name}</Text>
              <Text Text color="dimmed">
                {`${getSymbolFromCurrency(currency)}${default_payment_amount} ${default_payment_frequency}`}
              </Text>
            </Box>
          </Group>
        </Box>
        <Group spacing={5}>
          <Tooltip
            label="Link copied to clipboard"
            opened={copiedToClipboard === id}
            position="bottom"
            withArrow
          >
            <CopyToClipboard onCopy={onCopy} text={`https://sutra.co/space/${space_slug}/gateway?bundles=${id}`}>
              <Box
                ml={10}
                mt={10}
                className={classes.icon}
              >
                <FontAwesomeIcon icon={solid("link")} />
              </Box>
            </CopyToClipboard>
          </Tooltip>
          <Box
            ml={10}
            mt={10}
            className={classes.icon}
            onClick={(event) => {
              if (typeof onEdit === "function") {
                onEdit();
              }
            }}
          >
            <FontAwesomeIcon icon={solid("pencil")} />
          </Box>
          <Box
            ml={10}
            mt={10}
            className={classes.icon}
            onClick={(event) => {
              if (typeof onDestroy === "function") {
                onDestroy();
              }
            }}
          >
            <FontAwesomeIcon icon={solid("trash")} />
          </Box>
          <Box {...listeners} {...attributes} ml={10} mt={10} className={classes.icon}>
            <FontAwesomeIcon icon={solid("grip-vertical")} />
          </Box>
        </Group>
      </Group>
    </Box>
  );
};